/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Category_PremadeInputs */



/**
* | output |
* | --- |
* | "Premade" |
*
* @param {Voice_Manager_Elevenlabs_Category_PremadeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_category_premade = /** @type {((inputs?: Voice_Manager_Elevenlabs_Category_PremadeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Category_PremadeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prédéfinie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorgefertigt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Predefinita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Готовый")
	if (locale === "es") return /** @type {LocalizedString} */ ("Predefinida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वनिर्मित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Predefinida")
	return /** @type {LocalizedString} */ ("Premade")
});